import { render } from "./Register.vue?vue&type=template&id=99f278bc&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=99f278bc&scoped=true&lang=css"

import exportComponent from "D:\\projects\\APP\\vue3-ewshop\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f278bc"]])

export default __exports__